
interface BranchState {
  branches: any[];
  totalCount: number;
  loading: boolean;
  error: string | null;
  success: boolean;
  currentBranch: any | null;
  message: string | null;
}

const initialState: BranchState = {
  branches: [],
  totalCount: 0,
  loading: false,
  error: null,
  success: false,
  currentBranch: null,
  message: null
};
export default function branchReducer(state = initialState, action: any) {
  switch (action.type) {
    // Get Branches Cases
    case 'GET_BRANCH_REQUEST':
      return {
        ...state,
        loading: true,
        error: null,
      };

    case 'GET_BRANCH_SUCCESS':
      // Ensure we're always working with an array
      const branchesData = Array.isArray(action.payload.data.data) 
        ? action.payload.data.data 
        : [];
      
      return {
        ...state,
        loading: false,
        branches: branchesData,
        totalCount: action.payload.data.pagination?.total || 0,
        error: null,
      };

    case 'GET_BRANCH_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.payload,
        branches: [],
        totalCount: 0,
      };
        
            // Create Branch Cases
            case 'CREATE_BRANCH_REQUEST':
              return {
                ...state,
                loading: true,
                error: null,
                success: false,
              };
            case 'CREATE_BRANCH_SUCCESS':
              return {
                ...state,
                loading: false,
                success: true,
                currentBranch: action.payload.data.data,
                error: null,
                message: action.payload.data.message
              };
      
    
      case 'RESET_GET_BRANCH':
        return {
          ...state,
          branches: [],
          totalCount: null,
          error: null,
        };
  
    
      case 'CREATE_BRANCH_FAILURE':
        return {
          ...state,
          loading: false,
          error: action.payload.error,
          success: false,
        };
      case 'RESET_CREATE_BRANCH':
        return {
          ...state,
          currentBranch: null,
          error: null,
          success: false,
        };
  
      // Update Branch Cases
      case 'UPDATE_BRANCH_REQUEST':
        return {
          ...state,
          loading: true,
          error: null,
          success: false,
        };
      case 'UPDATE_BRANCH_SUCCESS':
        return {
          ...state,
          loading: false,
          success: true,
          currentBranch: action.payload.data.data,
          error: null,
        };
      case 'UPDATE_BRANCH_FAILURE':
        return {
          ...state,
          loading: false,
          error: action.payload.error,
          success: false,
        };
      case 'RESET_UPDATE_BRANCH':
        return {
          ...state,
          currentBranch: null,
          error: null,
          success: false,
        };
  
      // Delete Branch Cases
      case 'DELETE_BRANCH_REQUEST':
        return {
          ...state,
          loading: true,
          error: null,
          success: false,
        };
      case 'DELETE_BRANCH_SUCCESS':
        return {
          ...state,
          loading: false,
          success: true,
          error: null,
        };
      case 'DELETE_BRANCH_FAILURE':
        return {
          ...state,
          loading: false,
          error: action.payload.error,
          success: false,
        };
      case 'RESET_DELETE_BRANCH':
        return {
          ...state,
          error: null,
          success: false,
        };
  
      default:
        return state;
    }
  }